export const STEP_SUGGESTIONS = [
  {
    group: "Morning",
    items: [
      { label: "Wake up", icon: "Sun" },
      { label: "Wash face", icon: "Droplets" },
      { label: "Brush teeth", icon: "Brush" },
      { label: "Comb hair", icon: "Sparkles" },
      { label: "Get dressed", icon: "Shirt" },
      { label: "Eat breakfast", icon: "UtensilsCrossed" },
      { label: "Drink water", icon: "GlassWater" },
      { label: "Pack bag", icon: "Backpack" },
      { label: "Put on shoes", icon: "Footprints" },
    ],
  },
  {
    group: "Meals",
    items: [
      { label: "Wash hands", icon: "Hand" },
      { label: "Eat lunch", icon: "Sandwich" },
      { label: "Eat dinner", icon: "Salad" },
      { label: "Have a snack", icon: "Cookie" },
      { label: "Have a drink", icon: "CupSoda" },
      { label: "Clear the table", icon: "Check" },
    ],
  },
  {
    group: "Medication",
    items: [
      { label: "Take morning medicine", icon: "Pill" },
      { label: "Take afternoon medicine", icon: "Pill" },
      { label: "Take evening medicine", icon: "Pill" },
      { label: "Take medicine with water", icon: "GlassWater" },
      { label: "Use inhaler", icon: "Waves" },
    ],
  },
  {
    group: "Hygiene",
    items: [
      { label: "Use the toilet", icon: "Toilet" },
      { label: "Have a bath", icon: "Bath" },
      { label: "Have a shower", icon: "ShowerHead" },
      { label: "Take medicine", icon: "Pill" },
    ],
  },
  {
    group: "Out & about",
    items: [
      { label: "Put on coat", icon: "Shirt" },
      { label: "Get in the car", icon: "Car" },
      { label: "Take the bus", icon: "Bus" },
      { label: "Go to school", icon: "School" },
      { label: "Go shopping", icon: "ShoppingCart" },
      { label: "Go for a walk", icon: "Footprints" },
      { label: "Go to the cinema", icon: "Clapperboard" },
    ],
  },
  {
    group: "Appointments",
    items: [
      { label: "Go to therapy", icon: "HeartHandshake" },
      { label: "See the doctor", icon: "Stethoscope" },
      { label: "Dentist check-up", icon: "Smile" },
    ],
  },
  {
    group: "Sports & clubs",
    items: [
      { label: "Sports club", icon: "Trophy" },
      { label: "Play football", icon: "Volleyball" },
      { label: "Go swimming", icon: "Waves" },
      { label: "Win a medal", icon: "Medal" },
    ],
  },
  {
    group: "Church & worship",
    items: [
      { label: "Go to church", icon: "Church" },
      { label: "Sing songs", icon: "Music" },
      { label: "Quiet prayer", icon: "Sparkles" },
    ],
  },
  {
    group: "Bedtime",
    items: [
      { label: "Put on pyjamas", icon: "Moon" },
      { label: "Read a story", icon: "BookOpen" },
      { label: "Lights out", icon: "Moon" },
      { label: "Go to sleep", icon: "BedDouble" },
    ],
  },
  {
    group: "Other",
    items: [
      { label: "Play time", icon: "Play" },
      { label: "Screen time", icon: "Tv" },
      { label: "Watch a film", icon: "Popcorn" },
      { label: "Tidy up", icon: "Sparkles" },
      { label: "Quiet time", icon: "Clock" },
      { label: "Go home", icon: "Home" },
    ],
  },
];
